<template>
  <div>
    <div class="boss-layout boss-layout-vertical">
      <div>
        <Accordion :is-open="true">
          <template #head>
            よく使う項目
          </template>
          <template #body>
            <div class="boss-table-2">
              <scout-form-age v-model="searchData.parameter.age" />
              <scout-form-gender v-model="searchData.parameter.gender" />
              <scout-form-prefecture
                v-model="searchData.parameter.address.prefectures"
                :selected-option.sync="searchData.parameter.address.selectedOption"
                :contain-work-prefectures-non-hope-user.sync="searchData.parameter.address.containNonHopeUser"
                :show-annotation-label="true"
              />
              <scout-form-educational-background
                v-model="searchData.parameter.educationalBackground"
                :from.sync="searchData.parameter.graduatedSchool.year.from"
                :to.sync="searchData.parameter.graduatedSchool.year.to"
                :free-word.sync="searchData.condition.graduatedSchoolKeyword"
                :operator.sync="searchData.parameter.graduatedSchool.operator"
              />
              <scout-form-changed-jobs v-model="searchData.parameter.changeOverJobsCount.maximum" />
              <scout-form-employed v-model="searchData.parameter.employed" />
              <scout-form-annual-salary
                v-bind.sync="searchData.parameter.annualSalary"
                prefix="直近の"
              />
              <scout-form-annual-salary
                v-bind.sync="searchData.parameter.desiredSalary"
                prefix="希望の"
              />
              <scout-form-occupation
                :experienced-occupations.sync="searchData.parameter.occupations.experienced"
                :desired-occupations.sync="searchData.parameter.occupations.desired"
                :selected-option.sync="searchData.parameter.occupations.operator"
                :contain-occupations-non-hope-user.sync="searchData.parameter.occupations.containNonHopeUser"
              />
              <scout-form-sector
                :experienced-businesses.sync="searchData.parameter.businesses.experienced"
                :desired-businesses.sync="searchData.parameter.businesses.desired"
                :selected-option.sync="searchData.parameter.businesses.operator"
                :contain-businesses-non-hope-user.sync="searchData.parameter.businesses.containNonHopeUser"
              />
              <scout-form-skill
                v-model="searchData.parameter.skills.conditions"
                :selected-option.sync="searchData.parameter.skills.operator"
              />
              <scout-form-license
                v-model="searchData.parameter.licenses.ids"
                :selected-option.sync="searchData.parameter.licenses.operator"
              />
              <scout-form-behavior v-model="searchData.parameter.targetBehavior" />
              <scout-form-active-recent v-model.number="searchData.parameter.activeRecent" />
              <scout-form-others :has-career-resumes.sync="searchData.parameter.hasCareerResumes" />
            </div>
          </template>
        </Accordion>
      </div>
      <!-- さらに詳しい条件設定 -->
      <div>
        <Accordion :is-open="false">
          <template #head>
            さらに詳しい条件設定
          </template>
          <template #body>
            <div class="boss-table-2">
              <scout-form-language-skill
                :toeic.sync="searchData.parameter.toeicScore.minimum"
                :toefl.sync="searchData.parameter.toeflScore.minimum"
                :english.sync="searchData.parameter.englishSkill.minimum"
              />
              <scout-form-change-jobs-motivation v-model="searchData.parameter.changeJobsMotivations" />
              <scout-form-company-style v-model="searchData.parameter.companyStyle" />
              <scout-form-free-word
                v-model="searchData.condition.freeWord"
                :exclude-word.sync="searchData.condition.excludeWord"
                :operator.sync="searchData.parameter.freeWord.operator"
              />
              <scout-form-other-company-scouts v-model.number="searchData.parameter.excludedApproachedScout.otherCompany.maximum" />
              <scout-form-search-behavior
                :occupation.sync="searchData.parameter.searchingOccupations"
                :prefecture.sync="searchData.parameter.searchingWorkPrefectures"
                :sector.sync="searchData.parameter.searchingBusinesses"
              />
              <scout-form-registration-date
                :from.sync="searchData.condition.registrationDate_from"
                :to.sync="searchData.condition.registrationDate_to"
                :selected-option.sync="searchData.condition.selectedRegistrationDateValue"
              />
              <scout-form-resume-update-date
                :from.sync="searchData.condition.resumeUpdateDate_from"
                :to.sync="searchData.condition.resumeUpdateDate_to"
                :selected-option.sync="searchData.condition.selectedResumeUpdateDateValue"
              />
              <scout-form-active-date v-bind.sync="searchData.parameter.activeDate" />
              <scout-form-exclude
                :scout-this-job-option.sync="searchData.condition.selectedApproachedThisJobOptionValue"
                :scout-this-job-from.sync="searchData.condition.approachedThisJob_from"
                :scout-this-job-to.sync="searchData.condition.approachedThisJob_to"
                :scout-other-job-option.sync="searchData.condition.selectedApproachedOtherJobOptionValue"
                :scout-other-job-from.sync="searchData.condition.approachedOtherJob_from"
                :scout-other-job-to.sync="searchData.condition.approachedOtherJob_to"
                :liked-option.sync="searchData.condition.selectedLikedOptionValue"
                :liked-from.sync="searchData.condition.liked_from"
                :liked-to.sync="searchData.condition.liked_to"
                :applies-other-company.sync="searchData.parameter.excludeEntryOtherCompanyJob"
                :applies-casual-interview-entry-other-company.sync="searchData.parameter.excludeCasualInterviewEntryOtherCompanyJob"
                :has-candidate-other-job.sync="searchData.parameter.excludedCandidateOtherJob"
              />
              <scout-form-member-id
                v-model="searchData.parameter.userId"
                explanation="会員IDを入力した場合は他の検索条件は無効となります。"
              />
            </div>
          </template>
        </Accordion>
      </div>
      <div>
        <div class="boss-layout">
          <div class="boss-separated">
            <button
              class="boss-button boss-button-return"
              type="button"
              @click="back"
            >
              <span
                class="boss-button-return-text"
              >戻る
              </span>
            </button>
          </div>
        </div>
      </div>
      <!-- さらに詳しい条件設定 -->
    </div>
    <setting-auto-liked-search-trigger-container
      :search-count="searchCount"
      :is-searching="isSearching"
      :search-condition-id="Number(searchData.id)"
      :condition-name="searchData.name"
      :is-error="isError"
      @save="saveAutoLikedSearchCondition"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { SearchDataModel } from '@/model/searchDataModel'
import Accordion from '@/components/atoms/Accordion'
import ScoutFormActiveDate from '@/components/atoms/ScoutFormActiveDate'
import ScoutFormActiveRecent from '@/components/atoms/ScoutFormActiveRecent'
import ScoutFormAge from '@/components/atoms/ScoutFormAge'
import ScoutFormAnnualSalary from '@/components/atoms/ScoutFormAnnualSalary'
import ScoutFormBehavior from '@/components/atoms/ScoutFormBehavior'
import ScoutFormChangedJobs from '@/components/atoms/ScoutFormChangedJobs'
import ScoutFormChangeJobsMotivation from '@/components/atoms/ScoutFormChangeJobsMotivation'
import ScoutFormCompanyStyle from '@/components/atoms/ScoutFormCompanyStyle'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormExclude from '@/components/atoms/ScoutFormExclude'
import ScoutFormFreeWord from '@/components/atoms/ScoutFormFreeWord'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormLanguageSkill from '@/components/atoms/ScoutFormLanguageSkill'
import ScoutFormLicense from '@/components/atoms/ScoutFormLicense'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormOccupation from '@/components/atoms/ScoutFormOccupation'
import ScoutFormOtherCompanyScouts from '@/components/atoms/ScoutFormOtherCompanyScouts'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormRegistrationDate from '@/components/atoms/ScoutFormRegistrationDate'
import ScoutFormResumeUpdateDate from '@/components/atoms/ScoutFormResumeUpdateDate'
import ScoutFormSearchBehavior from '@/components/atoms/ScoutFormSearchBehavior'
import ScoutFormSector from '@/components/atoms/ScoutFormSector'
import ScoutFormSkill from '@/components/atoms/ScoutFormSkill'
import SettingAutoLikedSearchTriggerContainer from '@/components/molecules/SettingAutoLikedSearchTriggerContainer'

export default {
  components: {
    Accordion,
    ScoutFormActiveDate,
    ScoutFormActiveRecent,
    ScoutFormAge,
    ScoutFormAnnualSalary,
    ScoutFormBehavior,
    ScoutFormChangedJobs,
    ScoutFormChangeJobsMotivation,
    ScoutFormCompanyStyle,
    ScoutFormEducationalBackground,
    ScoutFormEmployed,
    ScoutFormExclude,
    ScoutFormFreeWord,
    ScoutFormGender,
    ScoutFormLanguageSkill,
    ScoutFormLicense,
    ScoutFormMemberId,
    ScoutFormOccupation,
    ScoutFormOtherCompanyScouts,
    ScoutFormOthers,
    ScoutFormPrefecture,
    ScoutFormRegistrationDate,
    ScoutFormResumeUpdateDate,
    ScoutFormSearchBehavior,
    ScoutFormSector,
    ScoutFormSkill,
    SettingAutoLikedSearchTriggerContainer
  },
  props: {
    baseConditionData: {
      type: Object,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      searchCount: null,
      searchData: new SearchDataModel(),
      isError: true,
      noDataSearchConditions: new SearchDataModel(),
      isEmptyChange: false,
      isSearching: false,
      // isEmptyChangeで検索の抑制をしているが、保存した検索条件編集からの遷移で検索されないパターンがあるため追加
      // operatorがある項目かつその項目の条件を未指定の場合がある場合に初回検索が走らない
      // 例
      // 1.職種 すべて合致 条件指定あり
      // 2.業種 いずれか合致 条件指定なし
      // の場合に発生
      isFirstSearched: false
    }
  },
  computed: {
    isFetchMembersCount () {
      return !_.isEqual(this.searchData, this.noDataSearchConditions) &&
        (!this.isEmptyChange || !this.isFirstSearched)
    }
  },
  watch: {
    'searchData.condition.graduatedSchoolKeyword' (val) {
      this.setKeywordsFromConditionToParameter(val, 'graduatedSchool')
    },
    'searchData.condition.freeWord' (val) {
      this.setKeywordsFromConditionToParameter(val, 'freeWord')
    },
    'searchData.condition.excludeWord' (val) {
      this.setKeywordsFromConditionToParameter(val, 'excludeWord')
    },
    // 最終ログインのバインド
    'searchData.condition.selectedRegistrationDateValue' (val) {
      this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeRangeForm', null)
      }
    },
    // NOTE: selectedDateTimeRangeForm内のプロパティは、optionId: ''の時にnullにしてほしいバックエンドの要望があるため、直接バインドできない
    'searchData.condition.registrationDate_from' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.registrationDate_to' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.to', val)
      }
    },
    // レジュメ更新日のバインド
    'searchData.condition.selectedResumeUpdateDateValue' (val) {
      this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.resumeUpdateDate_from' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.resumeUpdateDate_to' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.terms !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedThisJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedThisJob_from' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedThisJob_to' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedOtherJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedOtherJob_from' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedOtherJob_to' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedLikedOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedLiked, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedLiked, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.liked_from' (val) {
      if (this.searchData.condition.selectedLikedOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.liked_to' (val) {
      if (this.searchData.condition.selectedLikedOptionValue.terms !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.parameter.graduatedSchool.operator' () {
      this.checkChangeEmpty('condition.graduatedSchoolKeyword')
    },
    'searchData.parameter.address.selectedOption' () {
      this.checkChangeEmpty('parameter.address.prefectures')
    },
    'searchData.parameter.address.containNonHopeUser' () {
      this.checkChangeEmpty('parameter.address.prefectures')
    },
    'searchData.parameter.occupations.containNonHopeUser' () {
      this.checkChangeEmpty('parameter.occupations.desired')
    },
    'searchData.parameter.occupations.operator' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.occupations.experienced', 'parameter.occupations.desired'])
    },
    'searchData.parameter.businesses.containNonHopeUser' () {
      this.checkChangeEmpty('parameter.businesses.desired')
    },
    'searchData.parameter.businesses.operator' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.businesses.experienced', 'parameter.businesses.desired'])
    },
    'searchData.parameter.skills.operator' () {
      this.checkChangeEmpty('parameter.skills.conditions')
    },
    'searchData.parameter.licenses.operator' () {
      this.checkChangeEmpty('parameter.licenses.ids')
    },
    'searchData.parameter.freeWord.operator' () {
      this.checkChangeEmpty('condition.freeWord')
    },
    'searchData.parameter.excludeWord.operator' () {
      this.checkChangeEmpty('condition.excludeWord')
    },
    $route: {
      handler: 'fetchMembersCount'
    },
    searchData: {
      handler () {
        this.debouncedFetchMembersCount()
      },
      deep: true
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'prefectures',
      'occupations',
      'businesses',
      'languageSkills',
      'changeJobsMotivations',
      'companyStyles',
      'skills',
      'licenses'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
    this.debouncedFetchMembersCount = _.debounce(this.fetchMembersCount, 500)
    this.$set(this, 'searchData', _.cloneDeep(this.baseConditionData))
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    saveAutoLikedSearchCondition () {
      this.upsertSearchConditionIfNeed()
    },
    async upsertSearchConditionIfNeed () {
      const apiConditionParameter = _.cloneDeep(this.searchData)
      apiConditionParameter.parameter = this.createAPIParameter()
      apiConditionParameter.condition = JSON.stringify(apiConditionParameter.condition)
      await this.$emit('submit', apiConditionParameter)
    },
    fetchMembersCount () {
      if (this.isFetchMembersCount) {
        this.$set(this, 'isFirstSearched', true)
        const apiParameter = this.createAPIParameter()
        this.$set(this, 'isSearching', true)
        this.$http.secured.post(`/scout/message/send/contracts/${this.contractId}/jobs/${this.$route.params.jobId}/users/_auto_like_search/_count`, apiParameter).then(response => {
          if (_.isEqual(JSON.parse(response.config.data), this.createAPIParameter())) {
            this.$set(this, 'isError', false)
            this.$set(this, 'searchCount', response.data)
            this.$set(this, 'isSearching', false)
          }
        }).catch((error) => {
          // 現在の検索条件とAPIで投げた検索条件が一致している場合
          if (_.isEqual(JSON.parse(error.response.config.data), this.createAPIParameter())) {
            this.$set(this, 'isError', true)
            this.$set(this, 'isSearching', false)
          }
        })
      }
      this.isEmptyChange = false // 空更新フラグの初期化
    },
    createAPIParameter () {
      const apiParameter = _.cloneDeep(this.searchData.parameter)
      if (apiParameter.skills && apiParameter.skills.conditions) {
        apiParameter.skills.conditions = apiParameter.skills.conditions.filter(condition => condition.years.minimum !== '')
      }
      if (apiParameter.occupations.desired) {
        apiParameter.occupations.desired = apiParameter.occupations.desired.map(x => x.id)
      }
      if (apiParameter.occupations.experienced) {
        apiParameter.occupations.experienced = apiParameter.occupations.experienced.filter(x => x.years.minimum !== '')
      }
      return apiParameter
    },
    setKeywordsFromConditionToParameter (val, path) {
      const keywords = val.trim()
      if (keywords) {
        this.$set(this.searchData.parameter[path], 'keywords', (keywords.split(/\s+/g)))
      } else {
        this.$set(this.searchData.parameter[path], 'keywords', ([]))
      }
    },
    getWithinDaysFromTerms (val) {
      // selectedDateTime系の日数を取得する
      const terms = _.get(val, 'terms', '')
      if (terms === '' || terms === 'select') {
        // 初期値 / 未指定 / 日時指定の場合は、日数はnullで返却
        return null
      } else {
        return terms
      }
    },
    checkChangeEmpty (path) {
      // 設定値がない場合は検索が走らないよう抑制
      this.isEmptyChange = _.get(this.searchData, path, []).length === 0
    },
    updateIsEmptyChangeForNoDataPaths (paths = []) {
      // 複数項目に関係がある設定値がない場合は検索が走らないよう抑制
      this.isEmptyChange = !paths.some(path => _.get(this.searchData, path, []).length !== 0)
    },
    back () {
      this.$router.back()
    }
  }
}
</script>
